import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bo/organization-history/')({
  component: function Component() {
    const { organization } = useSearch({ strict: false })

    if (organization) {
      return (
        <Navigate
          replace
          to="/bo/organizations/$organizationTechnicalName/history"
          params={{ organizationTechnicalName: organization }}
        />
      )
    }

    return <Navigate replace to="/bo/organizations" />
  },
})
